<template>
	<div class="content-zsy" v-loading="loading" style="min-height: 400px;">
		<div v-show="!viewingDetailsId">
			<div class="widget-location">
				<h3>대행 신청/결제</h3>
			</div>
		<div class="list-top">
			<div class="">
				<span>전체 : <strong>{{total}}</strong> ( {{current_page}} / {{last_page}} 페이지 )</span>
			</div>
		</div>
		
		<el-table
		  :data="tableData" empty-text="데이터가 없습니다"
		  stripe 
		  style="width: 100%; cursor: pointer;">
			<el-table-column
			  prop="agency_type" v-if="!isMobile"
			  label="신청 대리 유형"
			  width="120">
			  <template slot-scope="scope">
					<div v-if="scope.row.agency_type == '1'" style="color:#409eff; font-weight: bold;">배송대행 신청</div>
					<div v-else-if="scope.row.agency_type == '2'" style="color:#67c23a; font-weight: bold;">구매대행 신청</div>	
			  </template>
			</el-table-column>
			<el-table-column  v-if="!isMobile"
			  label="배송방법 선택" width="90">
			  <template slot-scope="scope">
				<div v-if="scope.row.delivery_center_code == 'CN_SHIP'" >해상</div>
			  	<div v-else-if="scope.row.delivery_center_code == 'CN_AIR'" >항공</div>
				<div v-else-if="scope.row.delivery_center_code == 'CN_LCL'" >LCL화물</div>
			  </template>
			</el-table-column>
			<!-- <el-table-column  v-if="!isMobile"
			  label="통관방법 선택" width="150">
			  <template slot-scope="scope">
				<div v-if="scope.row.customs_type == '1'" style="color:#409eff;">간이통관</div>
			  	<div v-else-if="scope.row.customs_type == '2'" style="color:#67c23a;">목록통관</div>
				<div v-else-if="scope.row.customs_type == '3'" style="color:#67c23a;">사업자통관</div>	
			  </template>
			</el-table-column> -->
			<el-table-column label="신청 상세 정보" min-width="320">
			  <template slot-scope="scope">
				<div class="agency-info-row">
				  <!-- 1. 플랫폼 주문번호 -->
				  <div class="info-badge">
					<span class="badge-label">주문번호</span>
					<span class="badge-value">{{ scope.row.platform_order_no || '-' }}</span>
				  </div>
				  <!-- 2. 상품 총 금액(RMB) -->
				  <div class="info-badge">
					<span class="badge-label">총 금액</span>
					<span class="badge-value" style="color: #ff5700; font-weight: bold;">¥{{ scope.row.total_amount }}</span>
				  </div>
				  <!-- 3. 검토 상태 -->
				  <!-- <div class="info-badge">
					<span class="badge-label">검토상태</span>
					<span class="badge-value">
					  <span v-if="scope.row.audit_status == '0'" style="color:#409eff; font-weight: bold;">검토 대기</span>
					  <span v-else-if="scope.row.audit_status == '1'" style="color:#67c23a; font-weight: bold;">통과</span>
					  <span v-else-if="scope.row.audit_status == '2'" style="color:#f56c6c; font-weight: bold;">거절</span>
					</span>
				  </div> -->
				  <!-- 4. 작성일 -->
				  <div class="info-badge" v-if="!isMobile">
					<span class="badge-label">작성일</span>
					<span class="badge-value">{{ scope.row.createtime }}</span>
				  </div>
				</div>
			  </template>
			</el-table-column>
			<el-table-column label="메뉴" width="240">
				<template slot-scope="scope">
					<div style="display: flex; flex-wrap: wrap; gap: 6px; align-items: center;">
						<el-button size="mini" plain type="primary" icon="el-icon-view" @click="handleDetails(scope.$index, scope.row)">보기</el-button>
						
						<el-dropdown v-if="(scope.row.status >= 1 && scope.row.status <= 7) || scope.row.status == 30 || scope.row.status == 31 || scope.row.status == 32" trigger="click">
							<el-button size="mini" plain type="info">
								도구 <i class="el-icon-arrow-down el-icon--right"></i>
							</el-button>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item icon="el-icon-copy-document" @click.native="handleMerge(scope.row)">주문 합병</el-dropdown-item>
								<el-dropdown-item icon="el-icon-scissors" @click.native="handleSplitView(scope.row)">주문 분할</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
						<!-- shipment_status == 1 出库暂缓时 -->
						<el-button v-if="(scope.row.status == 6 || scope.row.status == 7) && scope.row.shipment_status == 1" size="mini" plain type="primary" icon="el-icon-s-promotion" @click="handleShipmentRequest(scope.row)">발송 신청</el-button>					
						<el-button v-if="scope.row.status >= 23 && scope.row.status <= 29" size="mini" plain type="warning" icon="el-icon-coin" @click="handleViewFees(scope.row)">운임</el-button>
						<el-button v-if="scope.row.agency_type == '2' && scope.row.pay_status == 0" size="mini" plain type="success" icon="el-icon-shopping-cart-full" @click="handleProductPayment(scope.row)">상품대금 결제</el-button>
						<el-button v-if="scope.row.status >= 26 && scope.row.status <= 29" size="mini" plain type="primary" icon="el-icon-truck" @click="handleTracking(scope.row)">국제 배송조회</el-button>
						
					</div>
				</template>
			</el-table-column>
		</el-table>
		
		<div class="page">
			<el-pagination
				layout="prev, pager, next" :page-size="20"
				:total="total"  @current-change="handleCurrentChange">
			</el-pagination>
		</div>
		
		
		<el-dialog title="운임 상세 내역" :visible.sync="feeDialogVisible" width="400px" custom-class="fee-dialog" center>
			<div v-if="selectedFeeInfo" class="fee-card">
				<!-- <div class="fee-section">
					<div class="fee-row">
						<span class="fee-label"><i class="el-icon-odometer"></i> 실제 중량</span>
						<span class="fee-value">{{ selectedFeeInfo.actual_weight || 0 }} kg</span>
					</div>
					<div class="fee-row">
						<span class="fee-label"><i class="el-icon-box"></i> 부피 중량</span>
						<span class="fee-value">{{ selectedFeeInfo.volume_weight || 0 }} kg</span>
					</div>
					<div class="fee-row highlight-row">
						<span class="fee-label"><i class="el-icon-truck"></i> 적용 중량</span>
						<span class="fee-value">{{ selectedFeeInfo.calc_weight || 0 }} kg</span>
					</div>
				</div>
				<div class="fee-divider"></div> -->

				<div class="fee-section">
					<div class="fee-row">
						<span class="fee-label">기본 운임</span>
						<span class="fee-value">₩ {{ selectedFeeInfo.shipping_fee || 0 }}</span>
					</div>
					<div class="fee-row">
						<span class="fee-label">부가 운임</span>
						<span class="fee-value">₩ {{ selectedFeeInfo.surcharge_fee || 0 }}</span>
					</div>
				</div>
				
				<div class="fee-divider dashed"></div>

				<div class="fee-row total-row">
					<span class="fee-label"><i class="el-icon-wallet"></i> 총 운임</span>
					<span class="fee-value total-amount">₩ {{ selectedFeeInfo.total_fee || 0 }}</span>
				</div>
				
				<!-- 商品总金额（仅在代购时显示） -->
				<!-- <div v-if="selectedFeeInfo.agency_type == '2'">
					<div class="fee-divider dashed" style="margin: 15px 0;"></div>
					<div class="fee-row" style="font-size: 15px; font-weight: bold;">
						<span class="fee-label"><i class="el-icon-shopping-cart-2"></i> 상품 총 금액</span>
						<span class="fee-value" style="color: #409EFF;font-size: 20px;">₩ {{ selectedFeeInfo.krw_amount || 0 }}</span>
						
					</div>
					<p style="text-align: right; font-size: 11px; color: #909399; margin: 6px 0 0 0;">※ 상품 총 금액은 실시간 환율에 따라 변동될 수 있습니다.</p>
				</div> -->

			</div>
			<span slot="footer" class="dialog-footer" style="display: flex; flex-direction: column; gap: 10px;">
				<!-- <div v-if="selectedFeeInfo && selectedFeeInfo.status == 23" style="text-align: center; font-size: 16px; font-weight: bold; margin-bottom: 5px;"> -->
				<div v-if="selectedFeeInfo && selectedFeeInfo.status == 23 " style="text-align: center; font-size: 16px; font-weight: bold; margin-bottom: 5px;">
					결제 금액: <span style="color: #f56c6c; font-size: 20px;">₩ {{ getPaymentAmount(selectedFeeInfo) }}</span>
				</div>
				<el-button v-if="selectedFeeInfo && selectedFeeInfo.status == 23" type="warning" round size="medium" @click="handlePayment(selectedFeeInfo)" style="width: 100%; margin: 0;">결제하기</el-button>
				<el-button type="primary" round size="medium" @click="feeDialogVisible = false" style="width: 100%; margin: 0;">닫기</el-button>
			</span>
		</el-dialog>

		<el-dialog title="상품대금 결제 상세" :visible.sync="productPaymentDialogVisible" width="400px" custom-class="fee-dialog" center>
			<div v-if="selectedOrderInfo" class="fee-card">
				<div class="fee-section">
					<div class="fee-row">
						<span class="fee-label"><i class="el-icon-goods"></i> 상품 금액 (CNY)</span>
						<span class="fee-value">{{ selectedOrderInfo.goods_amount || 0 }} ¥</span>
					</div>
					<div class="fee-row">
						<span class="fee-label"><i class="el-icon-percent"></i> 구매대행 수수료율</span>
						<span class="fee-value">{{ selectedOrderInfo.service_fee_rate || 0 }}%</span>
					</div>
					<div class="fee-row">
						<span class="fee-label"><i class="el-icon-info"></i> 서비스 수수료 (CNY)</span>
						<span class="fee-value">{{ selectedOrderInfo.service_fee || 0 }} ¥</span>
					</div>
					<div class="fee-divider dashed" style="margin: 12px 0;"></div>
					<div class="fee-row highlight-row">
						<span class="fee-label"><i class="el-icon-coin"></i> 총 결제 금액 (CNY)</span>
						<span class="fee-value" style="font-size: 18px; color: #67c23a;">{{ selectedOrderInfo.total_amount || 0 }} ¥</span>
					</div>
				</div>
				<p style="text-align: right; font-size: 11px; color: #909399; margin: 15px 0 0 0;">※ 상품 대금은 위안화(RMB)로 결제됩니다.</p>
			</div>
			<span slot="footer" class="dialog-footer" style="display: flex; flex-direction: column; gap: 10px;">
				<el-button v-if="selectedOrderInfo" type="success" round size="medium" @click="executeProductPayment(selectedOrderInfo)" style="width: 100%; margin: 0;">결제하기</el-button>
				<el-button type="primary" round size="medium" @click="productPaymentDialogVisible = false" style="width: 100%; margin: 0;">닫기</el-button>
			</span>
		</el-dialog>

		<el-dialog title="주문 합병" :visible.sync="mergeDialogVisible" width="700px" center :close-on-click-modal="false">
			<div style="margin-bottom: 15px; color: #666;">
				<i class="el-icon-info"></i> 선택한 주문과 동일한 [신청 유형, 배송지, 배송방법, 통관방법]을 가진 주문들입니다. 합병할 주문을 선택해주세요.
			</div>
			<el-table v-loading="mergeLoading" :data="mergeTableData" @selection-change="handleMergeSelectionChange" stripe border size="small" max-height="400">
				<el-table-column type="selection" width="55"></el-table-column>
				<el-table-column label="신청 대리 유형" width="120">
					<template slot-scope="scope">
						<div v-if="scope.row.agency_type == '1'" style="color:#409eff;">배송대행 신청</div>
						<div v-else-if="scope.row.agency_type == '2'" style="color:#67c23a;">구매대행 신청</div>
					</template>
				</el-table-column>
				<el-table-column label="배송방법 선택" width="110">
					<template slot-scope="scope">
						<div v-if="scope.row.delivery_center_code == 'CN_SHIP'">해상</div>
						<div v-else-if="scope.row.delivery_center_code == 'CN_AIR'">항공</div>
						<div v-else-if="scope.row.delivery_center_code == 'CN_LCL'">LCL화물</div>
					</template>
				</el-table-column>
				<el-table-column prop="platform_order_no" label="플랫폼 주문번호" min-width="180" show-overflow-tooltip></el-table-column>
				<el-table-column prop="createtime" label="작성일" width="150"></el-table-column>
			</el-table>
			<span slot="footer" class="dialog-footer">
				<el-button @click="mergeDialogVisible = false">취소</el-button>
				<el-button type="primary" @click="confirmMerge" :disabled="mergeSelection.length === 0">선택 주문 합병하기</el-button>
			</span>
		</el-dialog>

		<el-dialog title="주문 분할 (수량 추출)" :visible.sync="splitDialogVisible" width="800px" center :close-on-click-modal="false">
			<div style="margin-bottom: 15px; color: #666;">
				<i class="el-icon-scissors"></i> 새 주문으로 추출할 상품의 수량을 입력해주세요. 남은 수량은 현재 주문에 유지됩니다.
			</div>
			<el-table :data="splitGoodsList" stripe border size="small">
				<el-table-column label="상품 정보" min-width="200">
					<template slot-scope="scope">
						<div style="display: flex; align-items: center; gap: 10px;">
							<el-image :src="scope.row.goods_image" style="width: 40px; height: 40px; border-radius: 4px;" fit="cover">
								<div slot="error" class="image-slot" style="background: #f5f7fa; color: #909399; width: 100%; height: 100%; display: flex; align-items: center; justify-content: center; font-size: 20px;">
									<i class="el-icon-picture-outline"></i>
								</div>
							</el-image>
							<div style="font-size: 12px; line-height: 1.4;">{{ scope.row.goods_name }}</div>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="현재 수량" width="100" align="center">
					<template slot-scope="scope">
						<span style="font-weight: bold;">{{ scope.row.apply_quantity }}</span> 개
					</template>
				</el-table-column>
				<el-table-column label="추출(분할) 수량" width="180" align="center">
					<template slot-scope="scope">
						<el-input-number v-model="scope.row.extract_qty" :min="0" :max="scope.row.apply_quantity" size="mini" style="width: 120px;"></el-input-number>
					</template>
				</el-table-column>
			</el-table>
			<span slot="footer" class="dialog-footer">
				<el-button @click="splitDialogVisible = false">취소</el-button>
				<el-button type="primary" @click="confirmSplit" :loading="splitSubmitLoading">분할 실행하기</el-button>
			</span>
		</el-dialog>
		</div>

		<!-- 국제 배송조회 다이얼로그 -->
		<el-dialog title="국제 배송조회" :visible.sync="trackingDialogVisible" width="430px" custom-class="fee-dialog" center>
			<div v-if="trackingInfo" class="fee-card">
				<div class="fee-section">
					<div class="fee-row">
						<span class="fee-label"><i class="el-icon-truck"></i> 국제 택배 송장번호</span>
						<span class="fee-value" style="color: #409eff; font-weight: bold;">{{ trackingInfo.tracking_no || '-' }}</span>
					</div>
					<div class="fee-divider"></div>
					<div class="fee-row">
						<span class="fee-label"><i class="el-icon-time"></i> 발송 시간</span>
						<span class="fee-value">{{ trackingInfo.dispatchtime || '-' }}</span>
					</div>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" round @click="trackingDialogVisible = false">확인</el-button>
			</span>
		</el-dialog>

		<!-- 발송 신청 다이얼로그 发送申请对话框-->
		<el-dialog title="발송 신청 확인" :visible.sync="shipmentDialogVisible" width="450px" center>
			<div style="text-align: center; padding: 10px 0 20px; font-size: 15px; line-height: 1.6;" v-loading="imageLoading">
				<div v-if="shipmentImages && shipmentImages.length > 0" style="margin-bottom: 20px;">
					<div style="font-weight: bold; margin-bottom: 10px; color: #333; text-align: left;">
						<i class="el-icon-picture-outline"></i> 입고 실사 사진
					</div>
					<el-carousel trigger="click" height="250px" :autoplay="false" style="border-radius: 8px; box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);">
						<el-carousel-item v-for="(img, index) in shipmentImages" :key="index">
							<el-image 
								:src="img" 
								style="width: 100%; height: 100%;" 
								fit="contain" 
								:preview-src-list="shipmentImages">
							</el-image>
						</el-carousel-item>
					</el-carousel>
				</div>
				<i class="el-icon-warning-outline" style="font-size: 40px; color: #E6A23C; margin-bottom: 15px; display: block;"></i>
				<strong>해당 주문의 발송 신청을 진행하시겠습니까?</strong><br>
				<span style="color: #666; font-size: 13px;">발송 신청 후에는 정보 수정이 어려울 수 있습니다.</span>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="shipmentDialogVisible = false">취소</el-button>
				<el-button type="primary" :loading="shipmentLoading" @click="confirmShipmentRequest">발송 신청하기</el-button>
			</span>
		</el-dialog>

		<!-- 상세 정보 뷰 (Detail Info View) 详情-->
		<div v-if="viewingDetailsId && detailInfo" style="padding: 20px 0;" v-loading="detailLoading">
			<div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 24px; border-bottom: 2px solid #ebeef5; padding-bottom: 16px;">
				<h4 style="margin: 0; font-size: 20px; font-weight: bold; color: #303133;">대행 신청 상세 정보 (주문번호: {{detailInfo.platform_order_no || detailInfo.id}})</h4>
				<el-button type="primary" size="medium" icon="el-icon-back" round @click="closeDetails">목록으로 돌아가기</el-button>
			</div>

			<div style="min-height: 400px;">
				<!-- 프로세스 플로우 (Process Flow) -->
				<div style="margin-bottom: 30px; padding: 20px; background: #f8f9fa; border-radius: 8px; box-shadow: 0 1px 6px 0 rgba(0,0,0,0.03);">
					<el-steps :active="getActiveStep()" align-center finish-status="success" size="small">
						<el-step v-for="(step, index) in getSteps()" :key="index" :title="step.title" :description="step.description"></el-step>
					</el-steps>
				</div>

				<el-descriptions title="기본 신청 정보" direction="vertical" :column="isMobile ? 2 : 4" border style="margin-bottom: 24px;">
				  <el-descriptions-item label="신청 대리 유형">
					  <div v-if="detailInfo.agency_type == '1'" style="color:#409eff; font-weight: bold;">배송대행 신청</div>
					  <div v-else-if="detailInfo.agency_type == '2'" style="color:#67c23a; font-weight: bold;">구매대행 신청</div>	
				  </el-descriptions-item>
				  <el-descriptions-item label="배송방법 선택">
					  <div v-if="detailInfo.delivery_center_code == 'CN_SHIP'" >해상</div>
					  <div v-else-if="detailInfo.delivery_center_code == 'CN_AIR'" >항공</div>
					  <div v-else-if="detailInfo.delivery_center_code == 'CN_LCL'" >LCL화물</div>
				  </el-descriptions-item>
				  <el-descriptions-item label="통관방법 선택">
					  <div v-if="detailInfo.customs_type == '1'" style="color:#409eff;">간이통관</div>
					  <div v-else-if="detailInfo.customs_type == '2'" style="color:#67c23a;">목록통관</div>
					  <div v-else-if="detailInfo.customs_type == '3'" style="color:#67c23a;">사업자통관</div>	
				  </el-descriptions-item>
				  <el-descriptions-item label="회원명">{{formatValue(detailInfo.nickname)}}</el-descriptions-item>
				  <el-descriptions-item label="상품 총 금액">{{formatValue(detailInfo.total_amount)}}</el-descriptions-item>
				  <el-descriptions-item label="수취인명">{{formatValue(detailInfo.address?.consignee)}}</el-descriptions-item>
				  <el-descriptions-item label="영문 수취인명">{{formatValue(detailInfo.address?.en_consignee)}}</el-descriptions-item>
				  <el-descriptions-item label="우편번호">{{formatValue(detailInfo.address?.zipcode)}}</el-descriptions-item>
				  <el-descriptions-item label="핸드폰">{{formatValue(detailInfo.address?.mobile)}}</el-descriptions-item>
				  <el-descriptions-item label="개인통관고유부호">{{formatValue(detailInfo.address?.customs_info)}}</el-descriptions-item>
				  <el-descriptions-item label="주소" :span="2">{{formatValue(detailInfo.address?.address)}} {{detailInfo.address?.detailed_address}}</el-descriptions-item>
				  <el-descriptions-item label="국내 택배사 요청사항">{{formatValue(detailInfo.express_demand)}}</el-descriptions-item>
				  <el-descriptions-item label="제거 옵션">{{formatValue(detailInfo.remove)}}</el-descriptions-item>
				  <el-descriptions-item label="검수 레벨">{{formatValue(detailInfo.check_level)}}</el-descriptions-item>
				  <el-descriptions-item label="포장 레벨">{{formatValue(detailInfo.packing_level)}}</el-descriptions-item>
				  <el-descriptions-item label="추가 포장">{{formatValue(detailInfo.add_packing)}}</el-descriptions-item>
				  <el-descriptions-item label="결제 옵션">{{formatValue(detailInfo.pay_service)}}</el-descriptions-item>
				  <el-descriptions-item label="선/착불 구분">{{formatValue(detailInfo.service_cargo_type)}}</el-descriptions-item>
				  <el-descriptions-item label="FTA 세율 적용">{{formatValue(detailInfo.service_fta_type)}}</el-descriptions-item>
				  <el-descriptions-item label="관부가세 안내">{{formatValue(detailInfo.service_tariff_notify)}}</el-descriptions-item>
				  <!-- <el-descriptions-item label="검토 상태">
					  <div v-if="detailInfo.audit_status == '0'" style="color:#409eff; font-weight: bold;">검토 대기</div>
					  <div v-else-if="detailInfo.audit_status == '1'" style="color:#67c23a; font-weight: bold;">통과</div>
					  <div v-else-if="detailInfo.audit_status == '2'" style="color:#f56c6c; font-weight: bold;">거절</div>	
				  </el-descriptions-item> -->
				</el-descriptions>
				
				<div style="font-weight: bold; font-size: 15px; margin-bottom: 12px; color: #303133; padding-left: 4px; border-left: 4px solid #409eff;">신청 상품 정보</div>
				<div v-for="(item,index) in detailInfo.goods" :key="index" style="margin-bottom:20px; background: #fff; padding: 16px; border: 1px solid #ebeef5; border-radius: 8px;">
					<div style="font-size: 14px; font-weight: bold; margin-bottom: 14px; color: #303133;">{{item.goods_name}}</div>
					
					<!-- 상품 개별 프로세스 플로우 (Goods Process Flow) -->
					<div style="padding: 10px 10px 20px 10px; margin-bottom: 10px; background: #fafafa; border-radius: 6px;">
						<el-steps :active="getGoodsActiveStep(item)" :finish-status="getGoodsStepStatus(item) === 'error' ? 'error' : 'success'" :process-status="getGoodsStepStatus(item) === 'error' ? 'error' : 'process'" align-center size="small">
							<el-step title="대기"></el-step>
							<el-step title="구매중"></el-step>
							<el-step title="도착"></el-step>
							<el-step title="입고"></el-step>
							<el-step title="포장중"></el-step>
							<el-step title="발송완료"></el-step>
						</el-steps>
					</div>

					<el-descriptions direction="vertical" :column="isMobile ? 2 : 4" border size="small">
						<el-descriptions-item label="상품 이미지">
							<el-popover placement="right" trigger="hover" v-if="item.goods_image">
								<el-image 
									style="width: 150px; height: 150px" 
									:src="item.goods_image.startsWith('//') ? 'https:' + item.goods_image : item.goods_image" 
									fit="contain">
								</el-image>
								<el-image slot="reference"
									style="width: 50px; height: 50px; cursor: pointer; border-radius: 4px;"
									:src="item.goods_image.startsWith('//') ? 'https:' + item.goods_image : item.goods_image"
									fit="cover">
								</el-image>	
							</el-popover>
						</el-descriptions-item>
						<el-descriptions-item label="ID">{{formatValue(item.id)}}</el-descriptions-item>
						<el-descriptions-item label="상품 분류 ID">{{formatValue(item.category_id)}}</el-descriptions-item>
						<el-descriptions-item label="상품 상태">
							<span style="color: #409EFF; font-weight: bold;">{{formatValue(item.goods_status_text)}}</span>
						</el-descriptions-item>
						<el-descriptions-item label="택배 번호">{{formatValue(item.tracking_no)}}</el-descriptions-item>
						<el-descriptions-item label="사이즈">{{formatValue(item.size)}}</el-descriptions-item>
						<el-descriptions-item label="주문 번호">{{formatValue(item.order_no)}}</el-descriptions-item>
						<el-descriptions-item label="색상">{{formatValue(item.color)}}</el-descriptions-item>
						<el-descriptions-item label="단가">{{formatValue(item.price)}}</el-descriptions-item>
						<el-descriptions-item label="수량">{{formatValue(item.apply_quantity)}}</el-descriptions-item>
						<el-descriptions-item label="관리코드">{{formatValue(item.product_code)}}</el-descriptions-item>
						<el-descriptions-item label="포장박스수량">{{formatValue(item.box_count)}}</el-descriptions-item>
						<el-descriptions-item label="원산지작업(유료)">{{formatValue(item.origin)}}</el-descriptions-item>
						<el-descriptions-item label="포장보완(유료)">{{formatValue(item.package)}}</el-descriptions-item>
						<el-descriptions-item label="정밀검수(유료)">{{formatValue(item.check)}}</el-descriptions-item>
						<el-descriptions-item label="상품 URL">
							<a :href="item.url" target="_blank" style="color: #409eff; text-decoration: none;">링크 보기</a>
						</el-descriptions-item>
					</el-descriptions>
					<!-- 专属附加服务列表 -->
					<div v-if="item.attach_list && item.attach_list.length > 0" style="margin-top: 16px;">
						<div style="font-size: 14px; font-weight: bold; margin-bottom: 10px; color: #303133;">상품별 부가서비스</div>
						<el-table 
							:data="item.attach_list" 
							border 
							size="small"
							:header-cell-style="{ background: '#eef1f6', color: '#606266', fontWeight: 'bold' }"
							:cell-style="{ padding: '8px 0' }"
							style="width: 100%;">
							<el-table-column prop="name" label="서비스 항목" min-width="250"></el-table-column>
							<el-table-column prop="subtitle" label="상세 설명" min-width="200"></el-table-column>
							<el-table-column prop="num" label="수량" align="center" width="80">
								<template slot-scope="scope">
									<span v-if="!scope.row.has_num">-</span>
									<span v-else>{{ scope.row.num }}</span>
								</template>
							</el-table-column>
							<el-table-column prop="price" label="단가(원)" align="right" width="120">
								<template slot-scope="scope">
									{{ scope.row.price.toFixed(2) }}
								</template>
							</el-table-column>
							<el-table-column prop="total_price" label="합계(원)" align="right" width="120">
								<template slot-scope="scope">
									<strong>{{ scope.row.total_price.toFixed(2) }}</strong>
								</template>
							</el-table-column>
						</el-table>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import request from '@/utils/request'
	export default {
		data() {
			return {
				total:0,
				page:1,
				current_page:1,
				last_page:1,
				tableData: [],
				feeDialogVisible: false,
				productPaymentDialogVisible: false,
				selectedFeeInfo: null,
				selectedOrderInfo: null,
				mergeDialogVisible: false,
				mergeLoading: false,
				mergeTableData: [],
				mergeSelection: [],
				selectedMainId: null,
				splitDialogVisible: false,
				splitGoodsList: [],
				selectedSplitOrderId: null,
				splitSubmitLoading: false,
				loading: true,
				viewingDetailsId: null,
				detailLoading: false,
				detailInfo: null,
				trackingDialogVisible: false,
				trackingInfo: null,
				shipmentDialogVisible: false,
				shipmentLoading: false,
				selectedShipmentId: null,
				shipmentImages: [],
				imageLoading: false,
			};
		},
		computed: {
			isMobile() {
			  return window.innerWidth <= 768;
			}
		},
		created() {
			this.getList()
		},
		methods: {
			handleShipmentRequest(row) {
				this.selectedShipmentId = row.id;
				this.shipmentImages = [];
				this.imageLoading = true;
				this.shipmentDialogVisible = true;
				
				request.post('/member/Agency/getAgencyInstockImages', { id: row.id }).then(res => {
					this.imageLoading = false;
					if (res.code == 1) {
						this.shipmentImages = res.data || [];
					}
				}).catch(() => {
					this.imageLoading = false;
				});
			},
			confirmShipmentRequest() {
				this.shipmentLoading = true;
				// 修改状态 包装/称重(发货申请)
				request.post('/member/Agency/applyShipment', { id: this.selectedShipmentId }).then(res => {
					this.shipmentLoading = false;
					if (res.code == 1) {
						this.$message.success('발송 신청이 완료되었습니다.');
						this.shipmentDialogVisible = false;
						this.getList();
					} else {
						this.$message.error(res.msg || '발송 신청에 실패했습니다.');
					}
				}).catch(() => {
					this.shipmentLoading = false;
					this.$message.error('네트워크 오류가 발생했습니다.');
				});
			},
			handleTracking(row) {
				request.post('/member/Agency/getOutboundTracking', { id: row.id }).then(res => {
					if (res.code == 1) {
						this.trackingInfo = res.data;
						this.trackingDialogVisible = true;
					} else {
						this.$message.error(res.msg || '해당 정보가 없습니다.');
					}
				});
			},
			handleDetails(index, row) {
				this.viewingDetailsId = row.id;
				this.detailLoading = true;
				request.post('/member/Agency/getAgencyDetail', { id: row.id }).then(res => {
					this.detailLoading = false;
					if (res.code == 1) {
						this.detailInfo = res.data;
					} else {
						this.$message.error(res.msg || '상세 정보를 가져오는데 실패했습니다.');
						this.viewingDetailsId = null;
					}
				}).catch(() => {
					this.detailLoading = false;
					this.$message.error('오류가 발생했습니다.');
					this.viewingDetailsId = null;
				});
			},
			closeDetails() {
				this.viewingDetailsId = null;
				this.detailInfo = null;
			},
			formatValue(val) {
				if (val === null || val === undefined || val === '') {
					return '-';
				}
				if (Array.isArray(val) && val.length === 0) {
					return '-';
				}
				return val;
			},
			getSteps() {
				if (!this.detailInfo) return [];
				if (this.detailInfo.agency_type == '1') {
					return [
						{ title: '신청접수', description: '신청서 작성 완료' },
						{ title: '입고대기', description: '센터 입고 대기중' },
						{ title: '입고완료', description: '센터 입고 완료' },
						{ title: '운임결제', description: '배송비 결제 대기' },
						{ title: '국제배송', description: '해외 배송 진행' },
						{ title: '배송완료', description: '수취 완료' }
					];
				} else if (this.detailInfo.agency_type == '2') {
					return [
						{ title: '신청접수', description: '신청서 작성 완료' },
						{ title: '상품결제', description: '상품 대금 결제' },
						{ title: '구매/입고', description: '구매 및 센터 입고' },
						{ title: '입고완료', description: '센터 입고 완료' },
						{ title: '운임결제', description: '배송비 결제 대기' },
						{ title: '국제배송', description: '해외 배송 진행' },
						{ title: '배송완료', description: '수취 완료' }
					];
				}
				return [];
			},
			getActiveStep() {
				if (!this.detailInfo) return 0;
				const { agency_type, audit_status, pay_status, status, status_name, inventory_status } = this.detailInfo;
				const currentStatus = Number(status) || 0;
				
				if (audit_status == '2') {
					return 0;
				}
				
				const isStorageCompleted = [6, 7, 22].includes(currentStatus) || 
					(status_name && (status_name.includes('입고완료') || status_name.includes('일부입고'))) || 
					(inventory_status && (inventory_status.includes('입고완료') || inventory_status.includes('일부입고')));
				
				if (agency_type == '1') {
					if (audit_status == '0') return 0;
					if (currentStatus === 29) return 6;
					if (currentStatus >= 24 && currentStatus <= 28) return 4;
					if (currentStatus === 23) return 3;
					if (isStorageCompleted) return 2;
					return 1;
				} else if (agency_type == '2') {
					if (audit_status == '0') return 0;
					if (currentStatus === 29) return 7;
					if (currentStatus >= 24 && currentStatus <= 28) return 5;
					if (currentStatus === 23) return 4;
					if (isStorageCompleted) return 3;
					if (currentStatus === 30 || pay_status == '0') return 1;
					if (currentStatus === 31 || currentStatus === 32 || (currentStatus > 0 && currentStatus <= 5)) return 2;
					return 1;
				}
				return 0;
			},
			getGoodsActiveStep(item) {
				const s = Number(item.goods_status) || 0;
				const text = item.goods_status_text || '';
				
				if (s >= 50 && s < 60) return 6;
				if (s === 40 || text.includes('포장')) return 4;
				
				const isWarehoused = s === 35 || text.includes('입고완료') || text.includes('일부입고') || text === '입고';
				if (isWarehoused) return 3;
				
				if (s === 20 || s === 25 || s === 30 || text.includes('도착')) return 2;
				if (s === 15 || text.includes('구매')) return 1;
				if (s <= 10) return 0;
				if (s === 60) return 0;
				return 0;
			},
			getGoodsStepStatus(item) {
				const s = Number(item.goods_status) || 0;
				if (s === 25 || s === 60) return 'error';
				return 'success';
			},
			handleViewFees(row) {
				this.selectedFeeInfo = row;
				this.feeDialogVisible = true;
			},
			getPaymentAmount(info) {
				if (!info) return 0;
				let totalFee = Number(info.total_fee) || 0;
				//let productAmount = info.agency_type == '2' ? (Number(info.krw_amount) || 0) : 0;
				return totalFee; //+ productAmount;
			},
			handlePayment(row) {
				const amount = this.getPaymentAmount(row);
				this.$confirm(`현재 표시된 금액(₩ ${amount})으로 결제를 진행하시겠습니까?`, '결제 확인', {
					confirmButtonText: '확인',
					cancelButtonText: '취소',
					type: 'warning'
				}).then(() => {
					// 请在此处提交实际付款申请。
					request.post('/member/Paymentorder/payment', {
						id: row.id,
						source_type: 'agency', // 代理
						pay_rate:row.exchange_rate,//汇率
						
					}).then(res => {
						if (res.code == 1) {
							this.$message.success('결제가 완료되었습니다.');
							this.feeDialogVisible = false;
							this.getList();
						} else {
							this.$message.error(res.msg || '결제에 실패했습니다.');
						}
					}).catch(err => {
						console.error(err);
						this.$message.error('서버 오류가 발생했습니다.');
					});
				}).catch(() => {
					// 取消操作（无）
				});
			},
			handleProductPayment(row) {
				this.selectedOrderInfo = row;
				this.productPaymentDialogVisible = true;
			},
			executeProductPayment(row) {
				const amount = row.total_amount || 0;
				this.$confirm(`상품 대금(${amount} ¥)을 결제하시겠습니까?`, '결제 확인', {
					confirmButtonText: '확인',
					cancelButtonText: '취소',
					type: 'warning'
				}).then(() => {
					request.post('/member/Paymentorder/paymentGoods', {
						id: row.id,
						pay_rate: row.exchange_rate, //汇率
					}).then(res => {
						if (res.code == 1) {
							this.$message.success('결제가 완료되었습니다.');
							this.productPaymentDialogVisible = false;
							this.getList();
						} else if (res.data && res.data.code === 'NEED_EXCHANGE') {
							this.$confirm(`CNY 잔액이 부족합니다. 부족한 금액(¥${res.data.shortfall_cny})을 KRW 잔액(₩${res.data.needed_krw})에서 자동으로 환전하여 결제하시겠습니까? (적용 환율: ${res.data.rate})`, '자동 환전 및 결제 확인', {
								confirmButtonText: '환전 및 결제',
								cancelButtonText: '취소',
								type: 'warning'
							}).then(() => {
								request.post('/member/Paymentorder/paymentGoods', {
									id: row.id,
									pay_rate: row.exchange_rate,
									confirm_exchange: 1
								}).then(res2 => {
									if (res2.code == 1) {
										this.$message.success('환전 및 결제가 완료되었습니다.');
										this.productPaymentDialogVisible = false;
										this.getList();
									} else {
										this.$message.error(res2.msg || '결제에 실패했습니다.');
									}
								}).catch(err2 => {
									this.$message.error('결제에 실패했습니다.');
								});
							}).catch(() => {});
						} else {
							this.$message.error(res.msg || '결제에 실패했습니다.');
						}
					}).catch(err => {
						console.error(err);
						this.$message.error('서버 오류가 발생했습니다.');
					});
				}).catch(() => {});
			},
			handleCurrentChange(val) {
			    console.log(`当前页: ${val}`);
				this.page = val
				this.getList()
			},
			getList(){
				this.loading = true
				request.post('/member/Agency/agencyList',
					{
						page:this.page,	
					}
				).then(res => {
					this.loading = false
					console.log(res,"123")
					if(res.code ==1){
						this.total = res.data.total
						this.current_page = res.data.current_page
						this.last_page = res.data.last_page
						this.tableData= res.data.data
					}	
				}).catch(() => {
					this.loading = false
				});
				
			},
			handleMerge(row) {
				this.selectedMainId = row.id;
				this.mergeLoading = true;
				request.post('/member/Agency/getMergeableOrders', { id: row.id }).then(res => {
					this.mergeLoading = false;
					if (res.code == 1) {
						this.mergeTableData = res.data;
						this.mergeDialogVisible = true;
					} else {
						this.$message.error(res.msg || '데이터를 가져오는데 실패했습니다.');
					}
				}).catch(() => {
					this.mergeLoading = false;
					this.$message.error('오류가 발생했습니다.');
				});
			},
			handleMergeSelectionChange(val) {
				this.mergeSelection = val;
			},
			confirmMerge() {
				if (this.mergeSelection.length === 0) return;
				
				const mergeIds = this.mergeSelection.map(item => item.id);
				console.log(this.selectedMainId,"???")
				console.log(mergeIds,"???")
				//return
				this.$confirm(`선택한 ${mergeIds.length}개의 주문을 현재 주문에 합치시겠습니까? 합쳐진 주문은 삭제됩니다.`, '주문 합병 확인', {
					confirmButtonText: '확인',
					cancelButtonText: '취소',
					type: 'warning'
				}).then(() => {
					request.post('/member/Agency/mergeOrders', {
						main_id: this.selectedMainId,
						merge_ids: mergeIds
					}).then(res => {
						if (res.code == 1) {
							this.$message.success('주문이 성공적으로 합병되었습니다.');
							this.mergeDialogVisible = false;
							this.getList();
						} else {
							this.$message.error(res.msg || '합병에 실패했습니다.');
						}
					});
				}).catch(() => {});
			},
			handleSplitView(row) {
				this.selectedSplitOrderId = row.id;
				this.splitGoodsList = [];
				request.post('/member/Agency/getAgencyDetail', { id: row.id }).then(res => {
					if (res.code == 1) {
						// 增加 extract_qty 属性用于绑定输入
						this.splitGoodsList = res.data.goods.map(item => ({
							...item,
							extract_qty: 0
						}));
						this.splitDialogVisible = true;
					} else {
						this.$message.error(res.msg || '상품 정보를 가져오는데 실패했습니다.');
					}
				});
			},
			confirmSplit() {
				// 汇总要提取的数据
				const splitItems = this.splitGoodsList
					.filter(item => item.extract_qty > 0)
					.map(item => ({
						goods_id: item.id,
						quantity: item.extract_qty
					}));

				if (splitItems.length === 0) {
					this.$message.warning('최소 1개 이상의 상품 수량을 선택해주세요.');//请至少选择一个以上的商品数量。
					return;
				}
				console.log(splitItems,"items")
				console.log(this.selectedSplitOrderId,"id")
				//return

				// 检查是否将所有商品都提取走了（如果全部提取，建议提示）
				const totalOriginal = this.splitGoodsList.reduce((acc, cur) => acc + cur.apply_quantity, 0);
				const totalExtract = splitItems.reduce((acc, cur) => acc + cur.quantity, 0);
				
				if (totalExtract >= totalOriginal) {
					this.$message.warning('전체 수량을 분할할 수 없습니다. 일부 수량은 원본 주문에 남아야 합니다.');//不能拆分所有数量。部分数量必须保留在原始订单中。 
					return;
				}
				//是否按所选数量拆分为新订单？
				this.$confirm('선택한 수량만큼 새로운 주문으로 분할하시겠습니까?', '주문 분할 확인', {
					confirmButtonText: '확인',
					cancelButtonText: '취소',
					type: 'info'
				}).then(() => {
					this.splitSubmitLoading = true;
					request.post('/member/Agency/splitOrder', {
						id: this.selectedSplitOrderId,
						items: splitItems
					}).then(res => {
						this.splitSubmitLoading = false;
						if (res.code == 1) {
							this.$message.success('주문이 성공적으로 분할되었습니다.');//订单已成功分割
							this.splitDialogVisible = false;
							this.getList();
						} else {
							this.$message.error(res.msg || '분할에 실패했습니다.');//分割失败。	
						}
					}).catch(() => {
						this.splitSubmitLoading = false;
					});
				}).catch(() => {});
			}
		}
		
		
		
	}
</script>

<style scoped>
	.widget-location {
	    margin-top: 50px;
	    margin-bottom: 60px;
	    text-align: center;
	}
	.widget-location h3 {
	    padding: 0;
	    margin: 0;
	    font-size: 45px;
	    font-weight: bold;
	    color: var(--frontground-color);
	}
	.list-top {
	    display: flex;
	    align-items: center;
	    justify-content: space-between;
	    margin-bottom: 40px;
		padding:0 10px;
	}
	
	.page{
		padding-top: 20px;
		text-align: center;
	}
	::v-deep .el-table__header th {
		color: #333; 
		font-size: 13px;
		font-weight: bold;
	}
	::v-deep .el-descriptions-row th,
	::v-deep .el-descriptions-row td {
		min-height: 44px;
		height: 44px;
	}
	/* 分页背景 */
	::v-deep .el-pager li {
		background-color: var(--background-color);
	}
	::v-deep .el-pagination button:disabled {
		background-color: var(--background-color);
	}
	::v-deep .el-pagination .btn-next,::v-deep .el-pagination .btn-prev {
	    background: center center no-repeat var(--background-color);
	}
	
	.fee-card {
		background: #f8f9fc;
		border-radius: 8px;
		padding: 20px;
		box-shadow: inset 0 0 4px rgba(0,0,0,0.05);
	}
	.fee-section {
		display: flex;
		flex-direction: column;
		gap: 12px;
	}
	.fee-row {
		display: flex;
		justify-content: space-between;
		align-items: center;
		font-size: 14px;
		color: #606266;
	}
	.fee-label {
		display: flex;
		align-items: center;
		gap: 6px;
	}
	.fee-value {
		font-weight: 600;
		color: #303133;
	}
	.highlight-row {
		background: #eef5fe;
		padding: 8px 12px;
		border-radius: 6px;
		margin: -8px -12px;
		color: #409EFF;
	}
	.highlight-row .fee-value {
		color: #409EFF;
	}
	.fee-divider {
		height: 1px;
		background: #ebeef5;
		margin: 20px 0;
	}
	.fee-divider.dashed {
		border-top: 1px dashed #dcdfe6;
		background: transparent;
	}
	.total-row {
		font-size: 16px;
		color: #303133;
		font-weight: bold;
	}
	.total-amount {
		font-size: 20px;
		color: #f56c6c;
	}
	
	@media (min-width: 992px) {
		.content-zsy{
			width: 1270px;
			margin: 2.5rem auto;
		}
	}
	@media (max-width: 768px) {
		.widget-location h3 {
		    font-size: 30px;
		    font-weight: bold;
		    margin: 0;
		    word-break: keep-all;
		}
		
		.page{
			padding-bottom: 20px;
		}
		
	}
	.agency-info-row {
	    display: flex;
	    flex-wrap: wrap;
	    gap: 8px;
	    align-items: center;
	    padding: 4px 0;
	}
	.info-badge {
	    display: inline-flex;
	    align-items: center;
	    border: 1px solid #dcdfe6;
	    border-radius: 6px;
	    overflow: hidden;
	    font-size: 12px;
	    background: #fff;
	    line-height: 1.4;
	    box-shadow: 0 1px 2px rgba(0,0,0,0.02);
	}
	.badge-label {
	    background: #f5f7fa;
	    color: #606266;
	    padding: 5px 10px;
	    border-right: 1px solid #dcdfe6;
	    font-weight: bold;
	    white-space: nowrap;
	}
	.badge-value {
	    padding: 5px 12px;
	    color: #303133;
	    white-space: nowrap;
	}
</style>